import MasterService from "../../../services/common-services/MasterService";
import ManageAdminService from "../../../services/module-services/admin/ManageAdminService";
import NavigationBlocker from "../../../components/NavigationBlocker";

const ManageAdminHandler = {
  inject: ["navigationBlocker"],
  mixins: [ManageAdminService, MasterService],
  created() {
    this.navigationBlocker.val = true;
    let masterList = ["stateList", "countryCodeList", "genderList", "roleList"];
    if (!location.pathname.includes("/register/"))
      masterList = masterList.concat(["organisationList"]);
    this.loadMasterList(masterList);
    if (location.pathname.endsWith("/approvals")) {
      this.manageAdmin.page = "Approval";
    } else if (location.pathname.includes("/register/")) {
      this.manageAdmin.page = "Register";
    } else this.manageAdmin.page = "manage";
    if (this.$route.params.adminId) {
      this.UserForm.postData.id = this.$route.params.adminId;
      this.manageAdmin.id = this.$route.params.adminId;
      this.loadAdmin();
    }
    this.loadSelectedRole();
  },
  watch: {
    "master.roleList": function () {
      this.loadSelectedRole();
    },
  },
  methods: {
    loadSelectedRole() {
      let userType;
      if (
        this.$router.currentRoute.meta &&
        this.$router.currentRoute.meta.userType
      )
        userType = this.$router.currentRoute.meta.userType;
      else if (this.$route.params.userType)
        userType = this.$route.params.userType;
      if (userType && this.master.roleList.length > 0) {
        let selecetedRole = this.master.roleList.find(
          (x) => String(x.name).toLowerCase() == String(userType).toLowerCase()
        );
        if (!selecetedRole) this.$router.back();
        else {
          this.manageAdmin.role = selecetedRole;
          this.manageAdmin.userType = userType;
        }
      }
    },
    async isValidForm() {
      return await this.UserForm.isPersonalDataValid();
    },
    handleAdminApprove(isApproved) {
      this.navigationBlocker.val = true;
      this.UserForm.postData.isApproved = isApproved;
      this.saveAdmin();
    },
  },
  provide() {
    return {
      isValidForm: this.isValidForm,
      handleAdminApprove: this.handleAdminApprove,
      handleAdminSave: this.saveAdmin,
      handleAdminLoad: this.loadAdmin,
    };
  },
  template: `<div><slot></slot></div>`,
};

export default ManageAdminHandler;

export const withManageAdminHandler = (WrappedComponent) => {
  return {
    props: WrappedComponent.props,
    mixins: [NavigationBlocker],
    template: `<ManageAdminHandler><WrappedComponent v-bind="$props"></WrappedComponent></ManageAdminHandler>`,
    components: { ManageAdminHandler, WrappedComponent },
  };
};
